/* ═══════════════════════════════════════════
   THE QUIET EDITION v3 — Custom JS
   Minimal, product-forward
   ═══════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', () => {

  /* ── 1. Announcement Bar Rotation ─────────────────────────
     Cycles through Dawn announcement bar messages every 4s
     with a crossfade. Respects prefers-reduced-motion.
     ──────────────────────────────────────────────────────── */
  const announcementMessages = document.querySelectorAll('.announcement-bar__message');

  if (announcementMessages.length > 1) {
    const container = announcementMessages[0].closest('.announcement-bar') ||
                      announcementMessages[0].parentElement;

    /* Accessibility: let screen readers know content updates */
    if (container) container.setAttribute('aria-live', 'polite');

    /* Set up crossfade styles on each message */
    announcementMessages.forEach((msg, i) => {
      msg.style.transition = 'opacity 0.5s ease';
      msg.style.position = i === 0 ? '' : 'absolute';
      msg.style.opacity = i === 0 ? '1' : '0';
      msg.style.top = i === 0 ? '' : '0';
      msg.style.left = i === 0 ? '' : '0';
      msg.style.width = i === 0 ? '' : '100%';
      msg.setAttribute('aria-hidden', i === 0 ? 'false' : 'true');
    });

    /* Ensure parent is positioned for absolute children */
    if (container) container.style.position = 'relative';

    /* Respect reduced motion: show first message only, no rotation */
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (!prefersReducedMotion.matches) {
      let currentIndex = 0;

      setInterval(() => {
        const current = announcementMessages[currentIndex];
        currentIndex = (currentIndex + 1) % announcementMessages.length;
        const next = announcementMessages[currentIndex];

        /* Fade out current */
        current.style.opacity = '0';
        current.setAttribute('aria-hidden', 'true');
        current.style.position = 'absolute';
        current.style.top = '0';
        current.style.left = '0';
        current.style.width = '100%';

        /* Fade in next */
        next.style.opacity = '1';
        next.setAttribute('aria-hidden', 'false');
        next.style.position = '';
        next.style.top = '';
        next.style.left = '';
        next.style.width = '';
      }, 4000);
    }
  }


  /* ── 2. Countdown Timer ───────────────────────────────────
     Calculates time until next Friday 8PM GMT.
     Updates data-tqf-cd-* elements every second.
     Not shown by default — available for sections that need it.
     ──────────────────────────────────────────────────────── */
  function nextFriday8PM() {
    const now = new Date(), drop = new Date(now);
    drop.setUTCHours(20, 0, 0, 0);
    let d = (5 - drop.getUTCDay() + 7) % 7;
    if (d === 0 && now >= drop) d = 7;
    drop.setUTCDate(drop.getUTCDate() + d);
    return drop;
  }

  function pad(n) { return String(n).padStart(2, '0'); }

  function tickCountdowns() {
    const ms = nextFriday8PM() - new Date();
    if (ms <= 0) return;
    const d = pad(Math.floor(ms / 86400000));
    const h = pad(Math.floor(ms % 86400000 / 3600000));
    const m = pad(Math.floor(ms % 3600000 / 60000));
    const s = pad(Math.floor(ms % 60000 / 1000));

    document.querySelectorAll('[data-tqf-cd-d]').forEach(el => el.textContent = d);
    document.querySelectorAll('[data-tqf-cd-h]').forEach(el => el.textContent = h);
    document.querySelectorAll('[data-tqf-cd-m]').forEach(el => el.textContent = m);
    document.querySelectorAll('[data-tqf-cd-s]').forEach(el => el.textContent = s);
  }

  tickCountdowns();
  setInterval(tickCountdowns, 1000);


  /* ── 3. FAQ Accordion ─────────────────────────────────────
     Click or keyboard (Enter/Space) toggles parent .open
     class and aria-expanded attribute.
     ──────────────────────────────────────────────────────── */
  document.querySelectorAll('.tqf-faq-q').forEach(q => {
    /* Ensure keyboard focusability */
    if (!q.getAttribute('tabindex')) q.setAttribute('tabindex', '0');
    if (!q.getAttribute('role')) q.setAttribute('role', 'button');
    q.setAttribute('aria-expanded', 'false');

    function toggle() {
      const isOpen = q.parentElement.classList.toggle('open');
      q.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    q.addEventListener('click', toggle);

    q.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle();
      }
    });
  });


  /* ── 4. Fade-in on Scroll ─────────────────────────────────
     IntersectionObserver at 0.15 threshold adds .visible
     class to .tqf-fade-in elements once they enter viewport.
     ──────────────────────────────────────────────────────── */
  const fadeEls = document.querySelectorAll('.tqf-fade-in');

  if (fadeEls.length) {
    const fadeObs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          fadeObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });

    fadeEls.forEach(el => fadeObs.observe(el));
  }


  /* ── 5. Email Form Success ────────────────────────────────
     Prevents default submit, replaces form with styled
     success message using Newsreader italic.
     ──────────────────────────────────────────────────────── */
  document.querySelectorAll('.tqf-email-form').forEach(form => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      form.innerHTML =
        '<p style="font-family:\'Newsreader\',Georgia,serif; font-size:22px; font-style:italic; font-weight:300; color:#0a0a0a;">' +
        'You\u2019re in. Watch your inbox.</p>';
    });
  });

});

// TQF Size Guide link
document.addEventListener('DOMContentLoaded', function() {
  var target = document.querySelector('.product-form__input');
  if (!target) return;
  // The size guide snippet renders nothing for One Size products, so there is
  // no modal to open. Without this the button would render and do nothing.
  if (!document.getElementById('tqfSizeGuide')) return;
  var link = document.createElement('button');
  link.className = 'tqf-sg-link';
  link.textContent = 'Size guide';
  link.onclick = function() {
    var el = document.querySelector('[data-tqf-sg-tab]');
    var tab = el ? el.getAttribute('data-tqf-sg-tab') : 'wc';
    tqfOpenSizeGuide(tab);
  };
  target.parentNode.insertBefore(link, target);
});
